import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Logo from "../components/Logo";

export default function AuthCallback() {
  const { loginGoogle } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) { navigate("/login"); return; }
      try {
        await loginGoogle(sessionId);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard");
      } catch (e) {
        navigate("/login");
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FAFAF9] gap-4">
      <Logo className="h-14" />
      <div className="h-8 w-8 border-3 border-emerald-500 border-t-transparent rounded-full animate-spin" style={{ borderWidth: 3 }} />
      <p className="text-slate-500 text-sm">Signing you in...</p>
    </div>
  );
}
